import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
	palette: {
		primary: {
			light: '#BED600',
			main: '#036939',
			dark: '#00693C'
		},
		secondary: {
			main: '#14BD50'
		},
		error: {
			main: '#FE1C18'
		},
		info: {
			main: '#444444'
		},
		warning: {
			main: '#FFD219'
		}
	},
	typography: {
		h1: {
			fontSize: '6.75rem'
		},
		h2: {
			fontSize: '4.75rem'
		},
		h3: {
			fontSize: '3.75rem'
		},
		h4: {
			fontSize: '2.75rem'
		},
		h5: {
			fontSize: '1.75rem'
		},
		h6: {
			fontSize: '1.25rem'
		},
		body1: {
			fontSize: '1rem'
		}
	},
	overrides: {
		MuiCssBaseline: {
			'@global': {}
		}
	}
});

export default theme;